import React from 'react';
import { UnifiedMessage } from '../../types/whatsapp';
import { ChannelBadge } from './ChannelBadge';
import { CheckIcon, CheckCheckIcon, PlayIcon, FileTextIcon, MapPinIcon } from 'lucide-react';
import { useViewMode } from '../../context/ViewModeContext';
interface MessageItemProps {
  message: UnifiedMessage;
  locationCode?: string;
  locationName?: string;
}
export function MessageItem({
  message,
  locationCode,
  locationName
}: MessageItemProps) {
  const {
    viewMode
  } = useViewMode();
  const isDealer = message.from === 'dealer' || message.from === 'bot';
  const isSystem = message.from === 'system';
  if (isSystem) {
    return <div className="flex justify-center my-4" data-id="element-921">
        <span className="text-xs text-gray-500 bg-gray-100 px-3 py-1 rounded-full" data-id="element-922">
          {message.content} • {message.timestamp}
        </span>
      </div>;
  }
  return <div className={`flex ${isDealer ? 'justify-end' : 'justify-start'} mb-4 group`} data-id="element-923">
      <div className={`max-w-[75%] ${isDealer ? 'items-end' : 'items-start'} flex flex-col`} data-id="element-924">
        <div className="flex items-center space-x-2 mb-1 px-1" data-id="element-925">
          <span className="text-xs text-gray-500" data-id="element-926">
            {message.from === 'bot' ? 'Automated' : message.timestamp}
          </span>
          <ChannelBadge channel={message.channel} size="sm" data-id="element-927" />
        </div>

        <div className={`px-4 py-3 rounded-2xl shadow-sm relative ${message.channel === 'whatsapp' && isDealer ? 'bg-[#d9fdd3] text-gray-900 rounded-tr-none' : message.channel === 'sms' && isDealer ? 'bg-purple-100 text-gray-900 rounded-tr-none' : message.channel === 'email' && isDealer ? 'bg-orange-50 text-gray-900 border border-orange-100 rounded-tr-none' : message.channel === 'voice' ? 'bg-blue-50 border border-blue-100 text-gray-900' : message.from === 'bot' ? 'bg-gray-100 text-gray-800 rounded-tr-none' : 'bg-white text-gray-900 border border-gray-100 rounded-tl-none'}`} data-id="element-928">
          {/* Content based on type */}
          {message.type === 'call' ? <div className="flex items-center space-x-3 min-w-[200px]" data-id="element-929">
              <div className="w-8 h-8 rounded-full bg-blue-600 flex items-center justify-center text-white" data-id="element-930">
                <PlayIcon size={14} fill="currentColor" data-id="element-931" />
              </div>
              <div data-id="element-932">
                <p className="text-sm font-medium" data-id="element-933">
                  Voice Call • {message.metadata?.callDuration}
                </p>
                <p className="text-xs text-gray-500" data-id="element-934">
                  {message.status === 'missed' ? 'Missed Call' : 'Recording Available'}
                </p>
              </div>
            </div> : message.type === 'document' ? <div className="flex items-center space-x-3 bg-white/50 p-2 rounded-lg" data-id="element-935">
              <FileTextIcon size={24} className="text-red-500" data-id="element-936" />
              <div data-id="element-937">
                <p className="text-sm font-medium" data-id="element-938">Brochure.pdf</p>
                <p className="text-xs text-gray-500" data-id="element-939">1.2 MB</p>
              </div>
            </div> : <p className="text-sm whitespace-pre-wrap leading-relaxed" data-id="element-940">
              {message.content}
            </p>}

          {/* Status Indicator */}
          {isDealer && message.type !== 'call' && <div className="absolute bottom-1 right-2" data-id="element-941">
              {message.status === 'read' ? <CheckCheckIcon size={14} className="text-blue-500" data-id="element-942" /> : <CheckIcon size={14} className="text-gray-400" data-id="element-943" />}
            </div>}
        </div>

        {/* Location Badge - Only show for Brand view */}
        {viewMode === 'brand' && locationCode && <div className="flex items-center mt-1.5 px-1" data-id="element-944">
            <div className="inline-flex items-center px-2 py-0.5 bg-slate-100 rounded text-[10px] font-medium text-slate-600" data-id="element-945">
              <MapPinIcon size={10} className="mr-1" data-id="element-946" />
              {locationCode}
              {locationName && <span className="ml-1 text-slate-400" data-id="element-947">• {locationName}</span>}
            </div>
          </div>}
      </div>
    </div>;
}